define(["require", "exports", "./jwt"], function (require, exports, jwt_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.createTraceHeaderValue = exports.traceHeaderName = void 0;
    /**
     * The name of the HTTP header used for traceability in the requests.
     */
    exports.traceHeaderName = "opc-request-id";
    const createTraceId = () => {
        const c = globalThis.crypto;
        if (c === null || c === void 0 ? void 0 : c.randomUUID) {
            return c.randomUUID().replace(/-/g, "");
        }
        // Fallback for runtimes without crypto.randomUUID.
        return `${Date.now().toString(16)}${Math.random().toString(16).slice(2)}`;
    };
    /**
     * Creates a traceability value according to
     * https://confluence.oraclecorp.com/confluence/display/OSP/OCC+Distributed+Tracing+Considerations
     *
     * @param accessToken - the AT used for the current query or undefined
     * @returns - a HTTP header value
     */
    const createTraceHeaderValue = (accessToken) => {
        var _a, _b;
        const jti = accessToken ? (_b = (_a = (0, jwt_1.parseJwtClaims)(accessToken)) === null || _a === void 0 ? void 0 : _a.jti) !== null && _b !== void 0 ? _b : "" : "";
        return `${jti}/${createTraceId()}`;
    };
    exports.createTraceHeaderValue = createTraceHeaderValue;
});
